<div
    [hidden]="tabIndex !== parentTabs.tabIndex"
    [@slideInParamsFade]="{
      value: isActive ? '*' : 'void',
    params: {from: animationValue}
    }"
    >
    <ng-content></ng-content>
</div>
